import fetch from '../api/fetch'

/**
 * 	Action to fetch the Account list
 *
 * 	@method GET
 */

export function fetchAccountList(
    page: number = 1,
    perPage: number = 20,
    sortedBy: string = 'clientName',
    sortedType: string = 'asc'
) {

    let params = `?page=${page}&perPage=${perPage}&sortedBy=${sortedBy}&sortedType=${sortedType}`

    return {
        type: 'FETCH_ACCOUNT_LIST',
        payload: fetch(`/accounts${params}`, { method: 'GET' }),
    }
}

/**
 * 	Action to generate statement
 *
 * 	@method GET
 */

export function generateStatement() {
    return {
        type: 'GENERATE_STATEMENT',
        payload: fetch(`/accounts/generate_statement`, { method: 'GET' }),
    }
}

/**
 * 	Action to generate statement
 *
 * 	@method POST
 */

export function generateborderaux(bordereaux: any) {
    let params = `?bordereaux[from_date][day]=${bordereaux.bordereaux.from_date.day}`
        + `&bordereaux[from_date][month]=${bordereaux.bordereaux.from_date.month}`
        + `&bordereaux[from_date][year]=${bordereaux.bordereaux.from_date.year}`
        + `&bordereaux[to_date][day]=${bordereaux.bordereaux.to_date.day}`
        + `&bordereaux[to_date][month]=${bordereaux.bordereaux.to_date.month}`
        + `&bordereaux[to_date][year]=${bordereaux.bordereaux.to_date.year}`
    return {
        type: 'GENERATE_BORDEREAUX',
        payload: fetch(`/export_bordereaux${params}`, { method: 'POST' }),
    }
}

/**
 * 	Action to Delete Policy
 *
 * 	@method POST
 */

export function remove_entry(accountId: any) {
    return {
        type: 'REMOVE_ENTRY',
        payload: fetch(`/accounts/${accountId}/remove_entry`, { method: 'POST'}),
    }
}

/**
 * 	Action to Mark as paid Policy
 *
 * 	@method POST
 */

export function mark_as_paid(accountId: any) {
    return {
        type: 'MARK_AS_PAID',
        payload: fetch(`/accounts/${accountId}/mark_as_paid`, { method: 'POST'}),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/accounts.ts